import PropTypes from "prop-types"
import React from "react"
import TextChartODD13EmissionsEmployeeMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsEmployeeMolecule"
import TextChartODD13GHGEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13GHGEmissionsMolecule"
import ChartODD13EquipmentsGHGEmissionsMolecule from "views/molecules/canvases/charts/ChartODD13EquipmentsGHGEmissionsMolecule"
import ChartODD13GHGEmissionsDistributionConsolidateMolecule from "views/molecules/canvases/charts/ChartODD13GHGEmissionsDistributionConsolidateMolecule"
import TextChartODD13HighestITDomainEmissionsMolecule from "views/molecules/canvases/charts/TextChartODD13HighestITDomainEmissionsMolecule"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"
import ChartODD13GHGEmissionsInternalExternalMolecule from "views/molecules/canvases/charts/ChartODD13GHGEmissionsInternalExternalMolecule"
import ChartODD13ConsolidateChart3 from "views/molecules/canvases/charts/ChartODD13ConsolidateChart3"
import ChartODD13GhgPerVisitOrFallbackMolecule from "views/molecules/canvases/charts/ChartODD13GhgPerVisitOrFallbackMolecule"

const RegionScoreLayoutOrganism = ({ score, trendBadges }) => {

  const chart1TrendBadge = trendBadges?.odd13_CO2
  const chart2TrendBadge = trendBadges?.odd13_CO2_average_employee
  const maturityTrendBadge = trendBadges?.odd13_maturity



  return (
    <ScoreLayoutOrganism
      maturity={score.odd13_maturity ?? 0}
      maturityTrendBadge={maturityTrendBadge} 
      chart1={
        <TextChartODD13GHGEmissionsMolecule
          score={score}
          ghgEmissions={score?.odd13_CO2}
          hidePercentage={!score?.should_diplay_percentage}
          trendBadge={chart1TrendBadge}
        />
      }
      chart2={
        <ChartODD13GhgPerVisitOrFallbackMolecule
          score={score}
          fallback={
            <TextChartODD13EmissionsEmployeeMolecule
              score={score}
              trendBadge={chart2TrendBadge}
            />
          }
        />
      }
      chart3={<ChartODD13EquipmentsGHGEmissionsMolecule score={score} />}
      chart4={
        <ChartODD13GHGEmissionsDistributionConsolidateMolecule score={score} />
      }
      chart5={<TextChartODD13HighestITDomainEmissionsMolecule score={score} />}
      chart6={
        score?.odd13_ghg_internal_external_spit ? (
          <ChartODD13GHGEmissionsInternalExternalMolecule
            ghgSplit={score?.odd13_ghg_internal_external_spit}
          />
        ) : (
          <ChartODD13ConsolidateChart3 score={score} />
        )
      }
    />
  )
}

RegionScoreLayoutOrganism.propTypes = {
  score: PropTypes.object.isRequired,
  trendBadges: PropTypes.object,
}

RegionScoreLayoutOrganism.defaultProps = {
  trendBadges: {}, 
}

export default RegionScoreLayoutOrganism